<template>
  <vue-resizable
    ref="resizeBorders"
    :min-width="100"
    :min-height="100"
    :width="state.width"
    :height="state.height"
    :active="state.readonly ? [] : ['r', 'rb', 'b', 'lb', 'l', 'lt', 't', 'rt']"
    @resize:start="onResizeStart"
    @resize:end="onResizeEnd"
  >
    <div class="node frame" :class="[selected()]">
      <div class="title">
        <input 
          v-model="state.title" 
          class="title-input" 
          placeholder="Frame" 
          :readonly="state.readonly" 
          @input="emitUpdate"
        >
        <div class="frame-draggable" />
      </div>
    </div>
  </vue-resizable>
</template>

<script>
import VueResizable from 'vue-resizable';
import ReteVueRenderPlugin from 'rete-vue-render-plugin';
import $ from 'jquery';
import getEditorCoords from '../utils/getEditorCoords';

export default {
  name: 'action',
  components: {
    VueResizable,
  },
  mixins: [ReteVueRenderPlugin.mixin],
  props: {},
  data() {
    return {
      state: {
        width: this.node.data.width || 400,
        height: this.node.data.height || 400,
        title: this.node.data.title || '',
        readonly: false,
      },
    };
  },
  computed: {
  },
  created() {
    this.node.zIndex = -3; // one less than groups
    this.state.readonly = this.editor.readonly;
    this.editor.on('readonly', readonly => {
      this.state.readonly = readonly;
    });
  },
  mounted() {
    this.$nextTick(() => {
      $(this.node.vueContext.$el).parent().addClass('node frame');
    });
  },
  beforeDestroy() {},
  methods: {
    onResizeStart() {
      this.editor.trigger('disableNodeDrag', this.node);
    },
    onResizeEnd(e) {
      this.editor.trigger('enableNodeDrag', this.node);
      const position = getEditorCoords(this.$refs.resizeBorders, this.editor);
      const viewNode = this.editor.view.nodes.get(this.node);
      viewNode.translate(position[0], position[1]);
      this.state.width = e.width;
      this.state.height = e.height;
      this.emitUpdate();
      // Reset borders now that underlying node has been translated
      this.$refs.resizeBorders.l = 0;
      this.$refs.resizeBorders.t = 0;
    },
    emitUpdate() {
      this.node.data = {
        width: this.state.width,
        height: this.state.height,
        title: this.state.title,
      };
      this.editor.trigger('process', this.node);
    },
  },
};
</script>

<style scoped>
.node {
  width: 100%;
  height: 100%;
  color: white;
  border: solid 3px #d2dce6;
}

.node.selected {
  box-shadow: 0 3px 6px 0 rgba(255, 255, 255, 0.7);
  border: solid 4px #ffffff;
}

.title {
  display: flex;
}

.title-input {
  position: relative;
  height: 30px;
  top: -30px;
  border: none;
  background: none;
  font-size: 1.5rem;
  color: white;
}

.frame-draggable {
  position: relative;
  top: -30px;
  flex-grow: 1;
  cursor: pointer;
}
</style>
